import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading5 } from '@blueprint/heading';
import { ButtonLink } from '@blueprint/ui';

export const HeadingRow = styled('div')(
    ({ theme: { spacing } }) => css`
        margin-left: ${spacing['8px']};
        margin-bottom: ${spacing['24px']};
        display: flex;
        align-items: center;
        padding-right: ${spacing['8px']};
        ${Heading5} {
            margin-left: ${spacing['16px']};
        }
    `
);

export const StyledCenteringDiv = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        justify-content: 'center';
        ${ButtonLink} svg {
            margin-left: ${spacing['8px']};
        }
    `
);
